import React from 'react';
import { Redirect, Route } from 'react-router';

import PropTypes from 'prop-types';

import { PAGES } from '../../constants/pages';
import {
  retrieveFromSessionStorage,
  storeInSessionStorage,
} from '../../util/helpers/sessionStorageHelper';
import { JWT_REFRESH_TOKEN, JWT_TOKEN } from '../../constants/localStorage';
import useQuery from '../../util/hooks/useQuery';
import {
  BASIC_ACCOUNT_QUERY_DATA,
  IS_SALES_ASSESSTED_REGISTRATION_FLOW,
  IS_UPGRADE_FLOW,
} from '../../constants/sessionStorage';
import { addHeaderToken } from '../../request';

const PrivateRoute = ({ ...props }) => {
  const query = useQuery();
  const {
    token,
    accountCode,
    accountUid,
    jwtToken,
    refreshToken,
    logonUid,
    brokerCode,
    username,
  } = query;
  if (token && accountCode && accountUid) {
    storeInSessionStorage(IS_UPGRADE_FLOW, true);
    storeInSessionStorage(BASIC_ACCOUNT_QUERY_DATA, {
      accountCode,
      accountUid,
    });
  }
  if (logonUid && brokerCode && username) {
    storeInSessionStorage(IS_SALES_ASSESSTED_REGISTRATION_FLOW, true);
  }
  if (jwtToken && refreshToken) {
    addHeaderToken(jwtToken);
    storeInSessionStorage(IS_SALES_ASSESSTED_REGISTRATION_FLOW, true);
    storeInSessionStorage(JWT_TOKEN, jwtToken);
    storeInSessionStorage(JWT_REFRESH_TOKEN, refreshToken);
  }

  const isUpgradeFlow = retrieveFromSessionStorage(IS_UPGRADE_FLOW);
  const isSalesAssistedFlow = retrieveFromSessionStorage(
    IS_SALES_ASSESSTED_REGISTRATION_FLOW,
  );

  const JWTToken = retrieveFromSessionStorage(JWT_TOKEN);

  if (JWTToken || isUpgradeFlow || isSalesAssistedFlow) {
    return <Route {...props} />;
  }

  return <Redirect to={PAGES.BASE} />;
};

PrivateRoute.propTypes = {
  path: PropTypes.string,
};

export default PrivateRoute;
